// Client journey tabs
export const PRE_JOURNEY = 'preJourney';
export const FIRST_WEEK = 'firstWeek';
export const WEEKLY_CHECK_INS = 'weeklyCheckIns';
export const ALL_TASKS = 'allTasks';

// Client journey tabs screens
export const PRE_JOURNEY_SCREEN = 'Pre-journey';
export const FIRST_WEEK_SCREEN = 'First week';
export const WEEKLY_CHECK_INS_SCREEN = 'Weekly check-ins';

// Client journey tasks
export const FIRST_WEEK_COMPLETE = 'First week complete';
export const JOURNEY_KICK_OFF_CALL = 'Journey Kickoff Call';
export const DAY_ONE_CHECK_IN = 'Day one check-in';
export const DAY_TWO_CHECK_IN = 'Day two check-in';
export const DAY_THREE_CHECK_IN = 'Day three check-in';
export const DAY_FOUR_CHECK_IN = 'Day four check-in';
export const DAY_FIVE_CHECK_IN = 'Day five check-in';
export const FIRST_WEEK_CELEBRATION = 'First week Celebration';
export const COMPLETE_HEALTH_ASSESSMENT = 'Complete Health Assessment';
export const WELCOME_MESSAGE_SHOPPING_LIST = 'Welcome message & shopping list';
export const SHARE_OPTAVIA_APP = 'Share the OPTAVIA App';
export const WEEKLY_CHECK_IN = 'Weekly check-in';
export const COMPLETE_PRE_JOURNEY_TASKS = 'Complete pre-journey tasks';
export const JOURNEY_KICK_OFF_CALL_TASK = 'Journey kick-off call';

// First order statuses
export const IN_PROCESS = 'In Process';
export const PARTIALLY_SHIPPED = 'Partially Shipped';
export const SHIPPED = 'Shipped';
export const DELIVERED = 'Delivered';
export const CANCELLED = 'Cancelled';
export const RETURN_INITIATED = 'Return Initiated';
export const RETURN_RECEIVED = 'Return Received';
export const RETURN_COMPLETED = 'Return Completed';
export const ARRIVES = 'Arrives';
export const RESCHEDULED = 'Rescheduled';
export const COMPLETED = 'Completed';

// Tabs name from API
export const FIRST_TAB = 'screentab1';
export const SECOND_TAB = 'screentab2';
export const THIRD_TAB = 'screentab3';

// Pre-journey task details links

export const HEALTH_ASSESSMENT_TASK_DETAILS =
  'https://optaviamedia.com/pdf/learn/50036-OPTAVIA_Health-Assessment.pdf';
export const APP_STORE_LINK =
  'https://apps.apple.com/us/app/optavia/id1477201061';
export const ANDROID_LINK =
  'https://play.google.com/store/apps/details?id=com.optavia&hl=en_US&gl=US';
export const CLIENT_JOUNEY_TASK_DETAILS = 'Task Details';

export const CLIENT_JOURNEY = 'Client Journey';
